import { TAction } from './types/action';

// Action Types
export const SET_USER_AUTH = 'SET_USER_AUTH';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';

export type TSetUserAuthParams = {
  slug: string;
  params: Object;
};

// Action Creator
const UserAuthActionCreator = {
  setUserAuth(params: any): TAction<TSetUserAuthParams> {
    return {
      type: SET_USER_AUTH,
      payload: params
    };
  },
  showLoadingSpinner(show: boolean): TAction<boolean> {
    return {
      type: SHOW_LOADING_SPINNER,
      payload: show
    };
  }
};

export default UserAuthActionCreator;
